import { useProgress } from "@react-three/drei";
import * as THREE from 'three'
import { useThree } from "@react-three/fiber";
import ReactDOM from "react-dom/client";
import title from '../../public/staircasetitle.svg'

export default function LoadingScreen({started, onStarted}) {

    const {progress} = useProgress()
    console.log('progress: ', progress)

    return (
        <div className={`loadingScreen ${started ? 'loadingScreen-started': ''}`}>
                <div className='loadingScreen-container'>
                <img src={title} className='loading-title' alt="The Shepard Tone"/>
                {/* <h1 className="title">the Shepard<br/><div className="tone">Tone</div></h1> */}
                    <button 
                    disabled={progress < 100}
                    // onClick={onStarted}
                        className='loadingScreen_button'>{(progress < 100) ? 'loading' : "Discover the unsettling Shepard Tone effect. \n\n Move with WASD or arrow keys, look with the mouse. \n Initiate your journey with a click. \n Headphones recommended."}</button>

                <button 
                    disabled={progress < 100}
                    onClick={onStarted}
                        className='loadingScreen_overlay'></button>
                </div>

            <div className='loadingScreen_progress-top'>
                <div
                    className='loadingScreen_progress_value-top'
                    style={{
                        width: `${progress}vw`
                    }}
                >
                </div>
            </div>

            <div className='loadingScreen_progress-right'>
                <div
                    className='loadingScreen_progress_value-right'
                    style={{
                        height: `${progress}vh`
                    }}
                >
                </div>
            </div>

            <div className='loadingScreen_progress-bottom'>
                <div
                    className='loadingScreen_progress_value-bottom'
                    style={{
                        width: `${progress}vw`
                    }}
                >
                </div>
            </div>

            <div className='loadingScreen_progress-left'>
                <div
                    className='loadingScreen_progress_value-left'
                    style={{
                        height: `${progress}vh`
                    }}
                >
                </div>
            </div>

        </div>
    )

    
}